module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "icon_golden_ticket.526a8aff.svg";